import styled from 'styled-components';

import { BREAKPOINTS } from '~/src/common/theme';
import { getMediaQuery } from '~/src/common/theme/deprecated';

import { SCROLL_DESKTOP, SCROLL_MOBILE, SCROLL_MOBILE_RECIPE } from '../constants';

export const Container = styled.section`
  margin: 0;
  padding: 0;
  scroll-margin-top: ${SCROLL_DESKTOP}px;

  & + & {
    margin-top: 32px;
  }

  @media ${getMediaQuery(0, BREAKPOINTS.XL)} {
    scroll-margin-top: ${SCROLL_MOBILE}px;

    /* Surcharge si utilisation du menu recettes */
    aside:has([data-menu-mode='recipes']) ~ main & {
      scroll-margin-top: ${SCROLL_MOBILE_RECIPE}px;
    }
  }
`;
